import type { User } from '~/server/types';
import type { VariantPricing } from '@modules/product/util/get-variant-price';

type UserCategory = 'Customer' | 'Trade' | 'Guest';

export const getUserCategory = (user: User): UserCategory => {
    switch (user.__typename) {
        case 'Me':
            if (
                user.Professionals.length &&
                user.Professionals.filter((p) => p.IsManufacturer).length === 0
            ) {
                return 'Trade';
            }
            return 'Customer';
        case 'Guest':
            return 'Guest';
    }
};

export const canUserActionPrice = (
    user: User,
    price: VariantPricing | null,
): boolean => {
    const userCategory = getUserCategory(user);

    if (!price) {
        return false;
    }

    switch (userCategory) {
        case 'Customer':
            switch (price.PriceType) {
                case 'TradeProduct':
                    return false;
                case 'SpecialtyPricedTradeProduct':
                    return false;
                default:
                    return true;
            }

        case 'Trade':
            switch (price.PriceType) {
                case 'TradeProduct':
                    return true;
                case 'SpecialtyPricedTradeProduct':
                    return true;
                default:
                    return true;
            }
        case 'Guest':
            switch (price.PriceType) {
                case 'TradeProduct':
                    return false;
                case 'SpecialtyPricedTradeProduct':
                    return false;
                case 'CustomerProduct':
                    return false;
                default:
                    return true;
            }

        default:
            return false;
    }
};
